/**
 * NPC/Monster name_id → 한글 이름 매핑
 * 서버 S_NpcPack은 getNameId()($숫자 형식)를 그대로 보내므로
 * 클라이언트는 이 매핑으로 실제 이름을 표시한다.
 *
 * 데이터 출처: l1jdb.npcs 테이블 (1848 entries)
 * 자동 생성됨 — regenerate via db query if npcs table changes
 */

export const NPC_NAMES: Readonly<Record<string, string>> = Object.freeze({
  "$1242 $1044": "기란 임프",
  "$1242 $1045": "기란 임프 장로",
  "$1242 $1174": "기란 리자드 맨",
  "$1242 $1427": "기란 바 쿠쿠",
  "$1242 $1428": "기란 라미아",
  "$1242 $1430": "기란 크랩 맨",
  "$1242 $1432": "기란 조사원",
  "$1242 $1565": "기란 라바 골렘",
  "$1242 $1784": "기란 샤벨 타이거",
  "$1242 $1789": "기란 아이언 골렘",
  "$1242 $2105": "기란 다이어 울프",
  "$1242 $2107": "기란 키메라",
  "$1242 $319": "기란 옹골 리언 트",
  "$1242 $504": "기란 가스트",
  "$1242 $56": "기란 돌 골렘",
  "$1242 $619": "기란 가스트로드",
  "$1242 $925": "기란 켈베로스",
  "$13746 $19": "배신자 엘더",
  "$13746 $265": "사악한 셀로브",
  "$13746 $319": "사악한 웅 골리 언트",
  "$13746 $6": "사악한 괴물 눈",
  "$13752 $19": "배신자 엘더",
  "$13753 $4794": "부식 된 좀비 제네럴",
  "$13753 $4795": "부식 된 좀비 마법사",
  "$13753 $4797": "부식 된 해골 기사",
  "$13753 $57": "부식 된 좀비",
  "$13753 $986": "부식 된 해골 궁수",
  "$13753 $987": "부식 된 해골 도끼 병",
  "$13753 $988": "부식 된 해골 창병",
  "$1513 $2928": "butterfly",
  "$2129 $2928": "아덴 용병대",
  "$228 $1001": "저주받은 비홀더",
  "$228 $1174": "저주받은 리자드 맨",
  "$228 $1427": "저주받은 바쿡",
  "$228 $1428": "저주받은 라미아",
  "$228 $1431": "저주받은 랫맨",
  "$228 $1432": "저주받은 혈거 인간",
  "$228 $1490": "저주받은 머맨",
  "$228 $2113": "저주받은 메두사",
  "$228 $2482": "저주받은 물의 대 정령",
  "$228 $3729": "저주받은 거대 쥐",
  "$2470 $4326": "불의 시버",
  "$2931 $2928": "웰던 용병단",
  "$2931 $2930": "골키퍼",
  "$2932 $2928": "켄트 용병대",
  "$2933 $2928": "윈 다우드 용병단",
  "$2933 $2930": "윈 다우드 용병 대장",
  "$2933 군인": "윈 다우드 군인",
  "$33 $1385": "결혼식 게시판",
  "$3957 $4150": "오염 된 오크 창병",
  "$4145 $1110": "오염 된 오크 마법사",
  "$4145 $2481": "오염 된 불의 대 정령",
  "$4145 $2482": "오염 된 물의 대 정령",
  "$4145 $2483": "오염 된 바람의 대 정령",
  "$4145 $2551": "오염 된 땅의 대 정령",
  "$4145 $3148": "오염 된 딥 플라워",
  "$4145 $32": "오염 된 엘프",
  "$4145 $4144": "오염 된 빛의 대 정령",
  "$4145 $4146": "오염 된 인간",
  "$4145 $4152": "오염 된 어둠의 대 정령",
  "$4145 $4153": "오염 된 어둠의 대 정령의 소환물",
  "$4145 $4215": "오염 된 오크 도끼 병",
  "$4145 $4915": "오염 된 오크 투사",
  "$4327 $4326": "파도의 시버 인",
  "$4328 $4326": "불의 시버 인",
  "$4329 $4326": "바람의 시버 인",
  "$4330 $4326": "흙의 시버 인",
  "$4793 $2398": "부패한 좀비로드",
  "$4793 $4794": "부패한 좀비 장군",
  "$4793 $4795": "부패한 좀비 마법사",
  "$4793 $4796": "부패한 좀비 창병",
  "$4793 $4797": "부패한 해골 기사",
  "$4793 $57": "부패한 좀비",
  "$4793 $986": "부패한 해골 궁수",
  "$4793 $987": "부패한 해골 도끼 병",
  "$4793 $988": "부패한 해골 창병",
  "$4848 $1174": "돌연변이 리자드 맨",
  "$4848 $1428": "용감한 라미아",
  "$4848 $1430": "돌연변이 크랩 맨",
  "$4848 $1490": "돌연변이 머맨",
  "$4848 $18": "돌연변이 늑대 인간",
  "$4848 $990": "돌연변이 라이칸 스로프",
  "$4987 1": "순찰병 1",
  "$4987 2": "순찰병 2",
  "$4987 3": "순찰병 3",
  "$4987 4": "순찰병 4",
  "$4987 5": "순찰병 5",
  "$4987 6": "순찰병 6",
  "$4987 7": "순찰병 7",
  "$4987 8": "순찰병 8",
  "$4987 9": "순찰병 9",
  "$5228 $1429": "에바시 댄서",
  "$5228 $1430": "에바 크랩 맨",
  "$5228 $1433": "에바 일 렉카 둠",
  "$5228 $1492": "에바 크러스트 시안",
  "$5228 $1494": "에바 해파리",
  "$5228 $1496": "에바 상어",
  "$5228 $1497": "에바 아 스테",
  "$5228 $1498": "에바 터틀 드래곤",
  "$5253 $3124": "광폭 한 오움",
  "$5253 $3144": "광폭 한 헤비 오움",
  "$5253 $4294": "광포 한 해골 이르",
  "$7841 $1000": "마계의 서큐버스",
  "$7841 $1001": "마계의 게이",
  "$7841 $1016": "마계의 해골 저격병",
  "$7841 $1017": "마계의 해골 돌격 병",
  "$7841 $1018": "마계의 해골 근위병",
  "$7841 $1041": "마계의 오크 좀비",
  "$7841 $1393": "마계의 미노타우르스",
  "$7841 $1505": "마계의 도롱뇽",
  "$7841 $1562": "마계의 데스",
  "$7841 $1563": "마계의 유령",
  "$7841 $1565": "마계의 라바 골렘",
  "$7841 $1566": "마계의 불타는 전사",
  "$7841 $1567": "마계의 이프리트",
  "$7841 $1568": "마계의 혼 켈베로스",
  "$7841 $1572": "마계의 불타는 궁수",
  "$7841 $1580": "마계의 아시타 지오",
  "$7841 $2102": "마계의 가고일",
  "$7841 $2104": "마계의 레서 드래곤",
  "$7841 $2106": "마계의 그레이트 미노타우르스",
  "$7841 $2108": "마계의 본 드래곤",
  "$7841 $2397": "마계의 시어",
  "$7841 $2655": "마계의 타락의 사제",
  "$7841 $2658": "마계의 타락한 영혼",
  "$7841 $2895": "마계의 다크 엘리멘탈",
  "$7841 $318": "마계의 스파 토이",
  "$7841 $3413": "마계의 레서 데몬",
  "$7841 $3811": "마계의 헬 바운드",
  "$7841 $4148": "마계의 스피 리드",
  "$7841 $4868": "마계의 마이노",
  "$7841 $5650": "마계의 좀비 엘모어 마샬",
  "$7841 $7841": "마계의 혼돈의 사제",
  "$7841 $925": "마계의 켈베로스",
  "$7841 $990": "마계의 라이칸 스로프",
  "$7901 아줄": "해츨링 마법 인형 아주르",
  "$7901 크림슨": "해츨링 마법 인형 크림슨",
  "$7902 아줄": "하이 해츨링 마법 인형 아주르",
  "$7902 크림슨": "하이 해츨링 마법 인형 크림슨",
  "$914 $2928": "게 라드 용병단",
  "$972 선장": "드레이크 선장",
  "$6": "괴물 눈",
  "$7": "해골",
  "$8": "슬라임",
  "$18": "늑대 인간",
  "$19": "엘더",
  "$30": "선한 사자^미리에 루",
  "$56": "돌 골렘",
  "$57": "좀비",
  "$58": "난쟁이",
  "$59": "오크",
  "$240": "가이드",
  "$256": "개구리",
  "$265": "셀로브",
  "$266": "오크 전사",
  "$267": "오크 궁수",
  "$268": "늑대",
  "$269": "판도라",
  "$270": "군터",
  "$271": "독수리",
  "$272": "흑기사",
  "$274": "커츠",
  "$304": "발심",
  "$306": "바포메트",
  "$309": "창고지기^도린",
  "$317": "구울",
  "$318": "스파 토이",
  "$319": "웅 골리 언트",
  "$320": "선착장 관리인",
  "$325": "버그 베어",
  "$331": "네크로맨서",
  "$332": "케티",
  "$333": "룻",
  "$334": "창고지기^카림",
  "$335": "발타자르",
  "$336": "카스파",
  "$337": "메르 키 오르",
  "$338": "세마",
  "$371": "데스 나이트",
  "$374": "게렝",
  "$405": "크로 울링 크로",
  "$406": "오림",
  "$413": "왕관",
  "$430": "대장장이^게일",
  "$432": "이스마엘",
  "$445": "훈트",
  "$449": "카나",
  "$450": "로리아",
  "$451": "파르 보",
  "$452": "제 인트",
  "$453": "가이드",
  "$454": "렌고",
  "$455": "휜",
  "$456": "쥬디스",
  "$458": "안딘",
  "$459": "이소리 야",
  "$460": "'청상어'단",
  "$461": "무기 상점 '기적의 집'",
  "$462": "아이템 샵 '풍요의 꿈 \"",
  "$468": "창고지기^바 호후",
  "$478": "토마",
  "$479": "우드 포드",
  "$480": "옷호",
  "$481": "로한",
  "$482": "발가락 밴",
  "$483": "토미",
  "$484": "라이라",
  "$485": "골키퍼",
  "$486": "엘룬",
  "$487": "한나",
  "$488": "세겜 아 투바",
  "$489": "바즈 아아 투바",
  "$490": "오크 근위병",
  "$491": "네 나니 간지",
  "$492": "타가 로바",
  "$493": "가이드",
  "$494": "아 투바 오크",
  "$495": "black-rune",
  "$496": "간디 오크",
  "$497": "로바 오크",
  "$498": "두다 - 마라 오크",
  "$504": "가스트",
  "$511": "오크 스카우트",
  "$568": "창고지기^슬램",
  "$607": "오크 근위병",
  "$614": "존슨",
  "$615": "딕",
  "$619": "가스트로드",
  "$651": "이프리트",
  "$675": "이브",
  "$737": "밥",
  "$738": "누가",
  "$748": "숲과 요정의 어머니",
  "$749": "네루 파",
  "$750": "엘",
  "$751": "호런",
  "$752": "숲의 수호자^아라크네",
  "$753": "숲의 수호자^빵",
  "$754": "페어리",
  "$755": "엔트",
  "$757": "펑 거스",
  "$758": "브롭",
  "$805": "페어리 퀸",
  "$811": "나르 엔",
  "$812": "도 엣토",
  "$813": "후린 다렌",
  "$820": "모리 엔",
  "$821": "테오도르",
  "$829": "루카스",
  "$830": "아스터",
  "$831": "스텐리",
  "$832": "잭",
  "$833": "파울",
  "$834": "다니엘",
  "$835": "앤드류",
  "$836": "브르노",
  "$837": "시드니",
  "$838": "필립",
  "$839": "에반",
  "$840": "로드니",
  "$841": "가이드",
  "$842": "멘델",
  "$843": "제임스",
  "$844": "루크",
  "$846": "헥터",
  "$847": "렝고",
  "$848": "빈센트",
  "$849": "에버트",
  "$850": "콜버트",
  "$851": "알폰스",
  "$852": "빅터",
  "$853": "넬슨",
  "$854": "퍼킨",
  "$855": "제이슨",
  "$856": "라반",
  "$857": "란달",
  "$858": "세실",
  "$859": "디오",
  "$860": "안톤",
  "$861": "데렉",
  "$862": "모나",
  "$863": "헬렌",
  "$864": "엘리자",
  "$865": "모리아",
  "$866": "마가렛",
  "$867": "살리나",
  "$868": "제시",
  "$870": "제니",
  "$871": "베르 마",
  "$872": "앨리스",
  "$873": "에블린",
  "$874": "토비아",
  "$875": "릴",
  "$876": "알다",
  "$877": "아만다",
  "$878": "리나",
  "$879": "샐리",
  "$880": "데이지",
  "$881": "골키퍼",
  "$882": "타냐",
  "$883": "달리아",
  "$884": "도리스",
  "$885": "트레이시",
  "$886": "폴리",
  "$887": "올라",
  "$888": "마리나",
  "$889": "엠마",
  "$891": "베리 타",
  "$904": "세인트 버나드",
  "$905": "도베르만",
  "$906": "콜리",
  "$907": "세퍼드",
  "$908": "비글",
  "$910": "엘 미나",
  "$911": "가이드",
  "$912": "벨리 사",
  "$913": "데커",
  "$914": "게 라드",
  "$915": "글렌",
  "$916": "멜린",
  "$917": "대장장이^아논",
  "$918": "미란다",
  "$921": "오스 몬드",
  "$925": "켈베로스",
  "$927": "돼지",
  "$928": "암탉",
  "$929": "젖소",
  "$930": "사슴",
  "$931": "멧돼지",
  "$932": "란디 스",
  "$934": "아 놋테",
  "$935": "할트",
  "$936": "토끼",
  "$937": "킹 버그 베어",
  "$945": "베레스",
  "$946": "트레이",
  "$947": "메트",
  "$948": "창고지기^타킨",
  "$949": "창고지기^고담",
  "$950": "창고지기^보긴",
  "$952": "오리",
  "$953": "오우거",
  "$955": "셀레나",
  "$958": "고블린",
  "$959": "하피",
  "$960": "거대 개미",
  "$961": "거대 병정 개미",
  "$962": "바실리스크",
  "$963": "한스",
  "$964": "잭슨",
  "$965": "아슈르",
  "$966": "스콜피온",
  "$969": "라이프 스트림",
  "$970": "코볼트",
  "$972": "드레이크",
  "$986": "본 브레이크",
  "$987": "해골 도끼 병",
  "$988": "해골 창병",
  "$989": "트롤",
  "$990": "라이칸 스로프",
  "$991": "무리 안",
  "$992": "흑 장로",
  "$1000": "서큐버스",
  "$1001": "비홀더",
  "$1010": "에틴",
  "$1015": "클레이",
  "$1016": "해골 저격병",
  "$1017": "해골 돌격 병",
  "$1018": "해골 근위병",
  "$1019": "서큐버스 퀸",
  "$1041": "오크 좀비",
  "$1042": "다크 엘프",
  "$1043": "아이들 론",
  "$1044": "임프",
  "$1045": "임프 장로",
  "$1046": "그렘린",
  "$1047": "아울 베어",
  "$1053": "라 다르",
  "$1054": "파린",
  "$1055": "가이드",
  "$1056": "줄리",
  "$1057": "핀",
  "$1058": "골키퍼",
  "$1068": "케이스",
  "$1069": "해리슨",
  "$1070": "후퍼",
  "$1071": "콥",
  "$1072": "번치",
  "$1073": "창고지기^쿠 하팅",
  "$1110": "오크 마법사",
  "$1111": "홉 고블린",
  "$1112": "난쟁이 족 전사",
  "$1113": "사이클롭스",
  "$1116": "안타라스",
  "$1145": "에스트",
  "$1174": "리자드 맨",
  "$1175": "데몬",
  "$1176": "그리폰",
  "$1213": "베쿠도우",
  "$1214": "토토",
  "$1215": "버기",
  "$1216": "올",
  "$1217": "제프리",
  "$1218": "카이",
  "$1219": "아돌프",
  "$1220": "오바훗토",
  "$1221": "란뿌스",
  "$1222": "카",
  "$1223": "글루코",
  "$1224": "쿤도라",
  "$1225": "쿠마토",
  "$1226": "두렛쿠",
  "$1227": "구로돈",
  "$1228": "쿠ェ니바",
  "$1229": "플루트",
  "$1230": "두리바",
  "$1231": "바루아루",
  "$1232": "이레자",
  "$1233": "경매 관리자",
  "$1238": "오빌",
  "$1246": "허버트",
  "$1248": "창고지기^사우라 무",
  "$1249": "창고지기^노디 무",
  "$1250": "몰리",
  "$1259": "말콤",
  "$1260": "데이먼",
  "$1261": "타이 러스",
  "$1262": "샤윈",
  "$1263": "모란",
  "$1264": "페르디난드",
  "$1265": "지 레스",
  "$1266": "알도 레드",
  "$1267": "질리안",
  "$1268": "마르스",
  "$1269": "피에르",
  "$1270": "가스",
  "$1271": "올리버",
  "$1279": "루시우스",
  "$1286": "워너",
  "$1295": "버질",
  "$1298": "케빈",
  "$1299": "알몬",
  "$1301": "메이어",
  "$1306": "다이앤",
  "$1307": "베스",
  "$1308": "헨리에타",
  "$1309": "저스틴",
  "$1311": "밸 레스 카",
  "$1312": "카르멜",
  "$1313": "베 비나",
  "$1314": "리비아",
  "$1315": "질다",
  "$1316": "사라",
  "$1317": "테클라",
  "$1318": "엘리 노라",
  "$1319": "메어리",
  "$1320": "니 콜린 느",
  "$1321": "엘라 리아",
  "$1322": "줄리아",
  "$1323": "캐트리오나",
  "$1324": "미리 얌",
  "$1325": "멘 네퍼",
  "$1326": "오사",
  "$1327": "조안나",
  "$1328": "테오도라",
  "$1329": "마아 제리",
  "$1330": "글 레다",
  "$1331": "노 엘라",
  "$1332": "루 친다",
  "$1333": "미네르바",
  "$1334": "제랄딘",
  "$1335": "폴리나",
  "$1336": "에밀 라",
  "$1337": "줄리아나",
  "$1338": "살 로마",
  "$1339": "베레니스",
  "$1340": "카렐 리아",
  "$1341": "캐린 느",
  "$1342": "레오노라",
  "$1343": "이오네",
  "$1344": "기네 브라",
  "$1345": "두 아나",
  "$1346": "시그 리드",
  "$1347": "테사",
  "$1348": "에르 마",
  "$1354": "윌마",
  "$1362": "루 우루",
  "$1380": "창고지기^토휀",
  "$1383": "경매 게시판",
  "$1385": "게시판",
  "$1391": "놀",
  "$1392": "미믹",
  "$1393": "미노타우르스",
  "$1395": "아이스 골렘",
  "$1396": "페이퍼 맨",
  "$1397": "여우",
  "$1398": "자이언트",
  "$1404": "실루엣",
  "$1405": "인어",
  "$1406": "악어",
  "$1407": "악어",
  "$1408": "리빙 아머",
  "$1412": "시호 스",
  "$1414": "가이드",
  "$1415": "치료사",
  "$1416": "다크 엘프 레인저",
  "$1417": "이 쉬타",
  "$1418": "제노",
  "$1419": "벨 게터",
  "$1420": "프라 운",
  "$1422": "일드 라스",
  "$1423": "드리스트",
  "$1425": "말미잘",
  "$1426": "파 푸리 온",
  "$1427": "바쿡",
  "$1428": "라미아",
  "$1429": "시 댄서",
  "$1430": "크랩 맨",
  "$1431": "랫맨",
  "$1432": "혈거 인간",
  "$1433": "일 렉카 둠",
  "$1434": "부 아크",
  "$1435": "수호탑",
  "$1488": "에 브롤",
  "$1489": "가오리",
  "$1490": "머맨",
  "$1491": "실라칸스",
  "$1492": "크러스트 시안",
  "$1493": "물고기",
  "$1494": "해파리",
  "$1495": "곰",
  "$1496": "상어",
  "$1497": "아 스테",
  "$1498": "터틀 드래곤",
  "$1500": "결투장 안내 원",
  "$1501": "굿 맨",
  "$1502": "뉴트럴 맨",
  "$1503": "이블 맨",
  "$1504": "butterfly",
  "$1505": "사라만다",
  "$1506": "거대 여왕 개미",
  "$1510": "루디 엘",
  "$1511": "피셔",
  "$1512": "바 이거",
  "$1514": "엘란",
  "$1515": "시반",
  "$1516": "브리트",
  "$1517": "리올",
  "$1518": "데릭",
  "$1520": "골키퍼",
  "$1521": "트리 온",
  "$1522": "엘리나",
  "$1524": "알리",
  "$1525": "안나 베루",
  "$1526": "펠릭스",
  "$1527": "출창",
  "$1532": "골키퍼",
  "$1538": "창고지기^하킴",
  "$1539": "앨리",
  "$1540": "아디나",
  "$1541": "제니아",
  "$1542": "미리엄",
  "$1543": "에드 리",
  "$1544": "엘샤",
  "$1545": "트리오 나",
  "$1546": "로레나",
  "$1547": "노비타",
  "$1548": "모르나",
  "$1549": "델리아",
  "$1550": "다인",
  "$1551": "창고지기^하이도 리무",
  "$1554": "% i",
  "$1557": "근위병",
  "$1558": "가렛 트",
  "$1562": "데스",
  "$1563": "유령",
  "$1565": "라바 골렘",
  "$1566": "불타는 전사",
  "$1567": "이프리트",
  "$1568": "혼 켈베로스",
  "$1569": "피닉스",
  "$1570": "파이어 에그",
  "$1571": "폭탄 꽃",
  "$1572": "불타는 궁수",
  "$1579": "드래곤 플라이",
  "$1580": "아시타 지오",
  "$1591": "포 템핀",
  "$1592": "이 벨빈",
  "$1594": "베리",
  "$1595": "랄프",
  "$1596": "레슬리",
  "$1597": "코브",
  "$1598": "가빈",
  "$1599": "데일리",
  "$1600": "아탈라",
  "$1602": "프 렉슨",
  "$1604": "창고지기^에쿠 세론",
  "$1605": "발라카스",
  "$1609": "콜롯세움 관리인",
  "$1611": "창고지기^쿠리오 무",
  "$1624": "스텔라",
  "$1637": "콜드",
  "$1638": "아리에",
  "$1639": "모모",
  "$1640": "오킴",
  "$1641": "올드",
  "$1642": "진",
  "$1643": "근위병",
  "$1644": "티나",
  "$1653": "에스메랄다",
  "$1674": "신녀 아가타",
  "$1684": "변신 술사",
  "$1685": "방어구 강화 사",
  "$1686": "무기 강화 사",
  "$1695": "계곡 아울 베어",
  "$1696": "섬 가스트",
  "$1697": "섬 가스트로드",
  "$1698": "미완성 골렘",
  "$1699": "계곡 셸 로브",
  "$1700": "계곡 곰",
  "$1701": "섬 크로코다일",
  "$1702": "용감한 악어",
  "$1703": "돌연변이 도마뱀",
  "$1704": "계곡 하피",
  "$1705": "스타이 저",
  "$1706": "썩어가는 해골 저격병",
  "$1707": "썩어가는 해골 돌격 병",
  "$1708": "썩어가는 해골 근위병",
  "$1709": "섬 코카 트리스",
  "$1710": "퇴화 한 비홀더",
  "$1711": "계곡 라이칸 스로프",
  "$1713": "지친 랫맨",
  "$1714": "계곡 오우거",
  "$1715": "탈주 흑기사",
  "$1716": "굶주린 트롤",
  "$1718": "계곡 그리폰",
  "$1722": "큐 커스",
  "$1723": "계곡 바실리스크",
  "$1724": "리온",
  "$1725": "커스",
  "$1726": "물약 상인^키리스",
  "$1727": "음보",
  "$1728": "루바",
  "$1729": "티오",
  "$1730": "던전 텔레 포터^쿤",
  "$1731": "키 요리",
  "$1732": "파고",
  "$1737": "던전 텔레 포터^코코",
  "$1738": "스카이",
  "$1739": "저주받은 에틴",
  "$1740": "저주받은 버그 베어",
  "$1741": "지하 크랩 맨",
  "$1742": "지하 라미아",
  "$1743": "시군 바 쿠쿠",
  "$1744": "오염 된 오크 좀비",
  "$1745": "봉인 된 서큐버스 퀸",
  "$1746": "봉인 된 서큐버스",
  "$1747": "배회하는 무리 안",
  "$1748": "배회하는 웅 골리 언트",
  "$1749": "썩어가는 해골",
  "$1750": "괴물 버섯",
  "$1771": "얼음 여왕",
  "$1772": "마일드",
  "$1773": "키 리우스",
  "$1775": "비우스",
  "$1776": "만드 라",
  "$1777": "데 리안",
  "$1778": "타 라스",
  "$1779": "바뤼 에스",
  "$1780": "엘 뤼온",
  "$1781": "크리스 터",
  "$1782": "라즈 로스",
  "$1783": "눈사람",
  "$1784": "샤벨 타이거",
  "$1785": "エルモア ゾンビ ウィザード",
  "$1786": "에티",
  "$1787": "エルモア ジェネラル",
  "$1788": "허스키",
  "$1789": "아이언 골렘",
  "$1790": "エルモア ゾンビ ソルジャー",
  "$1791": "아이스 맨",
  "$1792": "비온",
  "$1793": "디마",
  "$1795": "데칸",
  "$1796": "로타 스",
  "$1797": "가르",
  "$1823": "데 후리",
  "$1824": "티파니",
  "$1825": "록",
  "$1826": "타 우스",
  "$1827": "비얀",
  "$1828": "엔케",
  "$1875": "린다",
  "$1876": "파고 르",
  "$1877": "디코",
  "$1878": "창고지기^히 리무",
  "$1897": "바르 니아",
  "$1898": "리 비안",
  "$1902": "콜롯세움 부 관리인",
  "$1925": "가이드",
  "$1926": "오스",
  "$1927": "제로",
  "$1928": "젬",
  "$1929": "흑기사 - 수색대",
  "$1931": "이스 발",
  "$1932": "아시리스",
  "$1944": "어 블리 젼",
  "$1953": "디텍터",
  "$1954": "치키",
  "$1955": "상점",
  "$1956": "티론",
  "$2004": "불의 정령",
  "$2005": "물의 정령",
  "$2006": "바람의 정령",
  "$2007": "땅의 정령",
  "$2008": "불의 대 정령",
  "$2009": "물의 대 정령",
  "$2010": "바람의 대 정령",
  "$2011": "땅의 대 정령",
  "$2012": "마크",
  "$2013": "골키퍼",
  "$2014": "골키퍼",
  "$2015": "문지기 개미",
  "$2016": "아리아",
  "$2017": "다크 마르",
  "$2018": "페어리 프린세스",
  "$2019": "디롱",
  "$2020": "언데드의 배신자",
  "$2021": "마샤",
  "$2037": "골키퍼",
  "$2063": "잭 오 랜턴",
  "$2064": "쟈쿠오 한 손전등",
  "$2073": "변종 거대 여왕 개미",
  "$2074": "변종 거대 병정 개미",
  "$2081": "배신자의 해골 근위병",
  "$2092": "오크 론",
  "$2098": "초보 텔레 포터",
  "$2099": "산적",
  "$2100": "산적 두목",
  "$2101": "도펠 갱어",
  "$2102": "가고일",
  "$2103": "나이트 메어",
  "$2104": "레서 드래곤",
  "$2105": "다이어 울프",
  "$2106": "그레이트 미노타우르스",
  "$2107": "키메라",
  "$2108": "본 드래곤",
  "$2109": "에이션트 자이언트",
  "$2110": "리치",
  "$2111": "댄싱 소드",
  "$2112": "레서 데몬",
  "$2113": "메두사",
  "$2114": "발록",
  "$2115": "젤라틴 큐브",
  "$2116": "린드 비 오르",
  "$2117": "켄 라우헬",
  "$2118": "케레니스",
  "$2121": "데프 만",
  "$2122": "라온",
  "$2123": "파우",
  "$2124": "창고지기^캠",
  "$2125": "창고지기^오기",
  "$2126": "시리우스",
  "$2127": "티몬",
  "$2128": "비우 스트",
  "$2130": "제시카",
  "$2131": "미사",
  "$2132": "마루 쟈",
  "$2133": "쵸비",
  "$2134": "빈 드로",
  "$2135": "마이키",
  "$2136": "아린",
  "$2137": "마틸다",
  "$2138": "에레 아노",
  "$2139": "제니퍼",
  "$2140": "셀마",
  "$2141": "리리아",
  "$2143": "세 리안",
  "$2144": "백 레이",
  "$2148": "로젠",
  "$2149": "제이미",
  "$2150": "마크",
  "$2151": "라파엘",
  "$2152": "골키퍼",
  "$2154": "아퀸",
  "$2157": "캘빈",
  "$2160": "리차드",
  "$2161": "맥",
  "$2163": "스빈",
  "$2165": "아덴 근위병",
  "$2166": "브레드",
  "$2167": "루키",
  "$2170": "타운 어드바이저",
  "$2171": "가이드",
  "$2204": "수호탑 : 에바",
  "$2205": "수호탑 : 파 아그 리오",
  "$2206": "수호탑 : 마 프르",
  "$2207": "수호탑 : 사 이하",
  "$2218": "얼음의 여왕 시녀",
  "$2219": "배신당한 오크 대장",
  "$2220": "배신당한 오크 궁수",
  "$2228": "창고지기^카 루디 무",
  "$2229": "창고지기^주크",
  "$2230": "창고지기^팅 뿌킨",
  "$2231": "캐서린",
  "$2232": "샤루",
  "$2233": "키닌",
  "$2234": "엘레리스",
  "$2235": "마구스",
  "$2236": "페가",
  "$2237": "멜리사",
  "$2238": "혈맹 집행 인",
  "$2254": "지무",
  "$2255": "자이언트 장로",
  "$2256": "자이언트 가디언",
  "$2257": "rune wall",
  "$2258": "헤이트",
  "$2259": "세피아",
  "$2260": "세피아의 죄",
  "$2261": "고대의 망령",
  "$2262": "신비한 바위",
  "$2263": "산적 부두목",
  "$2267": "디카 덴 솔저",
  "$2271": "오 디아",
  "$2272": "모린",
  "$2273": "캔디스",
  "$2274": "셀리나",
  "$2275": "신디",
  "$2276": "디나",
  "$2277": "에보니",
  "$2278": "리자",
  "$2279": "보비",
  "$2280": "레 빈스",
  "$2281": "아미에",
  "$2282": "리스",
  "$2284": "다이아나",
  "$2285": "나시",
  "$2286": "미첼",
  "$2287": "아카시아",
  "$2288": "민디",
  "$2289": "엔젤 린",
  "$2294": "에디에",
  "$2295": "아라나",
  "$2296": "베 버리",
  "$2297": "메요",
  "$2298": "프로 랜스",
  "$2299": "제네스",
  "$2300": "주디스",
  "$2301": "레시에",
  "$2302": "이사벨",
  "$2303": "로시 리",
  "$2304": "나디 네",
  "$2305": "시비 아",
  "$2306": "소피아",
  "$2307": "아 베리",
  "$2308": "카롯",
  "$2309": "로시스",
  "$2310": "쉬리에",
  "$2311": "셀레",
  "$2312": "안젤리나",
  "$2313": "미첼 리",
  "$2314": "나탈리아",
  "$2315": "비올 레트",
  "$2316": "마리 엘",
  "$2317": "비안카",
  "$2318": "벨라",
  "$2319": "플로리 네",
  "$2320": "완다",
  "$2321": "메이",
  "$2322": "조안",
  "$2323": "오펠리아",
  "$2324": "보니에",
  "$2325": "멜라",
  "$2326": "테레사",
  "$2327": "노나",
  "$2328": "사디에",
  "$2329": "브리티 네",
  "$2330": "탐 마라",
  "$2331": "루신다",
  "$2332": "안젤리카",
  "$2333": "첼 레네",
  "$2334": "루시에",
  "$2335": "카리 샤",
  "$2336": "실비아",
  "$2337": "제니스",
  "$2338": "니타",
  "$2339": "맥콜 리",
  "$2340": "도리에",
  "$2341": "헬레네",
  "$2342": "신녀 에리엘",
  "$2343": "전문가^헤이스트 사",
  "$2344": "쿠퍼",
  "$2345": "던햄",
  "$2355": "디 가르뎅",
  "$2356": "라무 다",
  "$2357": "고대인",
  "$2360": "발록의 추종자",
  "$2361": "고대인의 망령",
  "$2362": "분노한 고대인의 망령",
  "$2368": "발록의 창조물",
  "$2371": "파르 츠",
  "$2381": "돌연변이 웅 골리 언트",
  "$2382": "변종 라미아",
  "$2383": "사악한 비홀더",
  "$2384": "사악한 미믹",
  "$2385": "공포의 켈베로스",
  "$2386": "공포의 파이어 에그",
  "$2387": "난폭 한 스파 토이",
  "$2388": "난폭 한 해골 돌격 병",
  "$2389": "난폭 한 해골 도끼",
  "$2390": "난폭 한 해골 저격병",
  "$2391": "난폭 한 해골 창병",
  "$2392": "난폭 한 구울",
  "$2393": "화염의 고스트",
  "$2394": "화염의 네크로맨서",
  "$2395": "제니스 퀸",
  "$2398": "좀비로드",
  "$2399": "뱀파이어",
  "$2407": "공포의 아이언 골렘",
  "$2409": "박쥐",
  "$2431": "오크 장로",
  "$2432": "론드",
  "$2433": "타락한 경비병",
  "$2434": "리빌",
  "$2435": "데도 프",
  "$2436": "이카",
  "$2437": "토드",
  "$2438": "로덱",
  "$2439": "아트 신",
  "$2440": "토다",
  "$2441": "블루 디카",
  "$2442": "쿠프",
  "$2443": "어쌔신 마스터의 추종자",
  "$2444": "로제",
  "$2445": "어쌔신",
  "$2446": "어쌔신 마스터",
  "$2448": "하로",
  "$2481": "불의 대 정령",
  "$2482": "물의 대 정령",
  "$2483": "바람의 대 정령",
  "$2484": "킬러 비",
  "$2485": "볼 라이트닝",
  "$2487": "가디언 아머",
  "$2488": "유니콘",
  "$2489": "꿈의 혼령",
  "$2491": "하 데스티",
  "$2492": "레이 아스",
  "$2493": "공간 이동 사 에냐",
  "$2494": "스크와 티",
  "$2495": "다크 엘프 레인저",
  "$2496": "침묵의 동굴 마을 텔레 포터^카렌",
  "$2497": "에들 렌",
  "$2499": "칸의 말",
  "$2500": "론드의 말",
  "$2501": "론드의 암살 대",
  "$2502": "블루 디카의 암살 대",
  "$2544": "키마",
  "$2545": "론도",
  "$2546": "세리아",
  "$2548": "제티",
  "$2549": "키마 암살 대",
  "$2550": "데린",
  "$2551": "땅의 대 정령",
  "$2552": "세 디아",
  "$2554": "피에로",
  "$2556": "비숍",
  "$2557": "피어스",
  "$2558": "그랑 디크",
  "$2559": "하뮤도",
  "$2560": "에 루비 엔 누",
  "$2561": "라 뮤네",
  "$2562": "카린 누",
  "$2563": "열혈 토끼",
  "$2573": "페리아",
  "$2574": "로빈 후드",
  "$2586": "디아 노스",
  "$2587": "쿠거",
  "$2588": "나이트 발드",
  "$2589": "머미로드",
  "$2590": "그림 리퍼",
  "$2608": "바 무트",
  "$2609": "아이리스",
  "$2610": "저주의 오크 좀비",
  "$2611": "저주의 엘모어 병사",
  "$2612": "저주의 엘모어 마법사",
  "$2613": "저주의 엘모어 장군",
  "$2614": "어둠의 라이칸 스로프",
  "$2615": "냉혹 한 샤벨 타이거",
  "$2616": "화염의 혼 켈베로스",
  "$2617": "화염의 아시타 지오",
  "$2618": "다크 블랙 나이트",
  "$2619": "다크 불타는 전사",
  "$2620": "다크 불타는 궁수",
  "$2621": "암흑의 서큐버스 퀸",
  "$2622": "오만한 제니스 퀸",
  "$2623": "시어 주니어",
  "$2624": "마르퀴스 뱀파이어",
  "$2625": "공포의 좀비로드",
  "$2655": "타락의 사제",
  "$2656": "혼돈의 사제",
  "$2657": "죽음의 사제",
  "$2658": "타락한 영혼",
  "$2659": "엔디 아",
  "$2687": "rune wall",
  "$2688": "카 리프",
  "$2689": "류미엘",
  "$2690": "라비 엔 느",
  "$2692": "하이 도베르만",
  "$2693": "하이 베어",
  "$2694": "하이 세퍼드",
  "$2695": "하이 세인트 버나드",
  "$2696": "하이 폭스",
  "$2697": "하이 래빗",
  "$2698": "하이 비글",
  "$2699": "하이 허스키",
  "$2701": "고양이",
  "$2702": "하이 캣",
  "$2703": "하이 울프",
  "$2704": "하이 콜리",
  "$2705": "몽 테스",
  "$2708": "칸의 경비병",
  "$2717": "몽 테스의 말",
  "$2860": "조드",
  "$2861": "무기 방어구 상인^로 루코",
  "$2863": "리퍼",
  "$2883": "레이 다스",
  "$2885": "다크 엘프 제너럴",
  "$2886": "다크 엘프 시프",
  "$2887": "다크 엘프 솔저",
  "$2888": "다크 엘프 마법사",
  "$2890": "다크 엘프 가드",
  "$2891": "다크 엘프 비스트 테이머",
  "$2892": "다이어 뱃",
  "$2893": "다이어 베어",
  "$2894": "다크 엘리멘탈리스트",
  "$2895": "다크 엘리멘탈",
  "$2896": "그레이터 다크 엘리멘탈",
  "$2899": "파심",
  "$2921": "바라 스",
  "$2922": "쿠 노스",
  "$2923": "테라 누스",
  "$2924": "자이 루스",
  "$2927": "리만",
  "$2929": "무기 방어구 상인^프랑코",
  "$2934": "루즈",
  "$2938": "세라 티",
  "$2940": "부 루터스",
  "$2942": "케니 히",
  "$2943": "뮤 라스",
  "$2944": "까마귀",
  "$2945": "경비 병사",
  "$2982": "경비 대장",
  "$2983": "돌격 단장",
  "$2984": "야히의 분신",
  "$2985": "속박 된 영혼",
  "$2986": "사 르샤",
  "$2987": "흑기사 부대장",
  "$2995": "에이시 느",
  "$3013": "아덴 근위병",
  "$3041": "타이거",
  "$3042": "노세",
  "$3053": "시장 공간이 동사",
  "$3054": "시장 경비병",
  "$3055": "창고지기^정크",
  "$3070": "창고지기^크론",
  "$3071": "창고지기^토 라쿠",
  "$3072": "창고지기^구산",
  "$3118": "갱부 옴",
  "$3119": "수송 다크 엘프",
  "$3120": "프림",
  "$3121": "레이더",
  "$3122": "하구 틴",
  "$3123": "도망친 오움",
  "$3124": "오옴",
  "$3125": "장로 오움",
  "$3126": "성향 치 회복^속죄의 사자",
  "$3127": "공간 이동 사 디아 루즈",
  "$3128": "상인 카 루프",
  "$3129": "창고지기 가울",
  "$3130": "공간 이동 사 디아 베스",
  "$3131": "상인 에마 르트",
  "$3132": "창고지기 가린",
  "$3133": "작업 감독 오움",
  "$3134": "달프가 딘",
  "$3135": "레오나",
  "$3136": "블랙 타이거",
  "$3137": "서먼 엘리멘탈",
  "$3139": "라이아",
  "$3140": "비스트 서머너",
  "$3141": "블랙 위자드",
  "$3142": "다크 포레스터",
  "$3143": "블랙 엔트",
  "$3144": "헤비 오움",
  "$3145": "미들 오움",
  "$3146": "딜로",
  "$3147": "플레이트 웜",
  "$3148": "딥 플라워",
  "$3149": "두더지",
  "$3159": "다크 엘프 사냥꾼",
  "$3160": "다크 엘프 어 프렌 티스",
  "$3161": "레딩",
  "$3162": "트리스탄",
  "$3164": "반스",
  "$3166": "랑스",
  "$3167": "코데 랏지",
  "$3168": "제 스틴",
  "$3169": "스 미터",
  "$3170": "얀 스팅",
  "$3180": "아덴 정찰병",
  "$3181": "올레",
  "$3182": "수감중인 다크 엘프",
  "$3187": "라 블라",
  "$3188": "라 보르",
  "$3223": "창고지기^데닛 쯔",
  "$3224": "창고지기^카샤 무",
  "$3225": "유노",
  "$3234": "블 레즈",
  "$3237": "아덴 상단",
  "$3238": "왕궁 게이트 키퍼",
  "$3239": "요새 게이트 키퍼",
  "$3270": "지저 크랩 맨",
  "$3271": "지저 대왕 거북",
  "$3272": "지저 리자드 맨",
  "$3273": "지저 대왕 벌레",
  "$3274": "지저 일 렉카 둠",
  "$3275": "지저 전갈 미스틱",
  "$3276": "지저 전갈 파이 탄",
  "$3277": "지저 비홀더",
  "$3316": "레크 만",
  "$3317": "세 리안",
  "$3318": "리리",
  "$3319": "기온",
  "$3320": "시리아",
  "$3321": "오실 리아",
  "$3322": "호닌",
  "$3323": "치코",
  "$3324": "홉",
  "$3325": "터크",
  "$3326": "갈리온",
  "$3327": "길버트",
  "$3328": "포리 칸",
  "$3329": "제릭",
  "$3330": "자루 만",
  "$3331": "래리",
  "$3332": "래리의 보좌관",
  "$3333": "래리의 병사",
  "$3378": "와일드 베놈",
  "$3379": "와일드 팡",
  "$3380": "와일드 매직",
  "$3381": "매드 리자드 맨",
  "$3382": "하이 리자드 맨",
  "$3383": "헤비 리자드 맨",
  "$3387": "라버 본",
  "$3388": "라버 본 솔져",
  "$3389": "라버 본 헤드",
  "$3407": "타락",
  "$3409": "거대한 무덤 가디언",
  "$3410": "무덤 가디언 나이트",
  "$3411": "무덤 가디언 메이지",
  "$3412": "무덤 가디언",
  "$3414": "발록의 분신",
  "$3415": "칼 바스의 하인",
  "$3416": "고대 자이언트 장군",
  "$3417": "고대 자이언트 장로",
  "$3418": "수감 된 아덴 용병",
  "$3419": "밧슈",
  "$3420": "로이",
  "$3421": "아덴성의 공주",
  "$3424": "보보",
  "$3427": "오베르",
  "$3428": "잡화 상인^니키",
  "$3436": "듀발",
  "$3437": "듀란",
  "$3438": "록산느",
  "$3448": "아덴 왕궁 요리사",
  "$3449": "아르카",
  "$3462": "맘보 토끼",
  "$3463": "맘보 토끼 졸개",
  "$3464": "화염의 이빨",
  "$3465": "빙하의 이빨",
  "$3466": "바람의 이빨",
  "$3467": "대지의 이빨",
  "$3468": "화령의 주인",
  "$3469": "수령의 주인",
  "$3470": "풍령의 주인",
  "$3471": "지령의 주인",
  "$3472": "심연의 화령",
  "$3473": "심연의 수령",
  "$3474": "심연의 풍령",
  "$3475": "심연의 지령",
  "$3476": "심연의 주인",
  "$3477": "심연의 구울",
  "$3478": "심연의 궁수",
  "$3479": "씽",
  "$3480": "연금술사",
  "$3508": "라쿤",
  "$3509": "블루 테일",
  "$3510": "하이 라쿤",
  "$3511": "키위 패롯",
  "$3515": "발록의 레서 데몬",
  "$3516": "발록의 데몬",
  "$3517": "발록의 서큐버스",
  "$3518": "발록의 서큐버스 퀸",
  "$3519": "발록의 바포메트",
  "$3520": "발록의 베레스",
  "$3523": "고대의 정령",
  "$3525": "밀레",
  "$3526": "창고지기^쿠드",
  "$3527": "베릭",
  "$3529": "듀론",
  "$3530": "포니",
  "$3531": "카 미트",
  "$3548": "콘술",
  "$3550": "넓은 하늘 동 텔레 포터",
  "$3551": "정령의 오브",
  "$3552": "가이드",
  "$3555": "시미즈",
  "$3556": "도일",
  "$3557": "도일의 개",
  "$3558": "루케 인",
  "$3559": "카드 무스",
  "$3560": "레스타",
  "$3561": "루디안",
  "$3563": "티 구스",
  "$3564": "지 다르",
  "$3565": "펫 관리인^골목",
  "$3566": "레너드",
  "$3567": "작은 상자",
  "$3590": "아덴 정보원",
  "$3591": "페스 코",
  "$3592": "루보",
  "$3593": "리앤",
  "$3594": "루니",
  "$3595": "로베르토",
  "$3596": "루푸스",
  "$3597": "카루",
  "$3599": "fountain d aden",
  "$3600": "fountain c aden",
  "$3601": "자일즈",
  "$3726": "쿠만",
  "$3727": "디에고",
  "$3728": "호세",
  "$3729": "거대 쥐",
  "$3730": "라버 본 나이프",
  "$3731": "rune wall",
  "$3732": "카미 라의 유령",
  "$3733": "리자드 맨 장로",
  "$3734": "리자드 맨 청년 전사",
  "$3777": "rune",
  "$3778": "혼돈",
  "$3779": "죽음",
  "$3780": "죽음의 성도",
  "$3781": "죽음의 사제",
  "$3782": "죽음의 성도",
  "$3785": "야히의 근위병",
  "$3798": "암살 군왕 슬레이브",
  "$3799": "암살 단장 블레이즈",
  "$3800": "친위대 장 카이트",
  "$3801": "피의 암살자",
  "$3802": "어둠의 도적",
  "$3803": "라스타바드 친위대",
  "$3804": "마수 군왕 바란카",
  "$3805": "마수 단장 카이 바르",
  "$3806": "사단장 싱클레어",
  "$3807": "여단장 다크 팬더",
  "$3808": "라스타바드 조련사",
  "$3809": "울프 라이더",
  "$3811": "헬 바운드",
  "$3812": "헬 크리처",
  "$3813": "크림슨 드레이크",
  "$3814": "팬텀 나이트",
  "$3815": "마령 군왕 라이아",
  "$3816": "신 관장 바운티",
  "$3817": "마법 단장 카르 미엘",
  "$3818": "물의 정령 가디언",
  "$3819": "불 정령 수호자",
  "$3820": "땅의 정령 수호자",
  "$3821": "바람 정령 수호자",
  "$3822": "어둠 정령 수호자",
  "$3823": "어둠 숲지기",
  "$3824": "암흑 마법사",
  "$3825": "명법 군왕 헬 바인",
  "$3826": "명법 단장 쿠리화스",
  "$3827": "용병 대장 메 파이 스토",
  "$3828": "어둠의 복수 자",
  "$3829": "블러디 나이트",
  "$3830": "오움 전사",
  "$3831": "헤비 오움 전사",
  "$3832": "피의 강령 술사",
  "$3833": "다크로드",
  "$3941": "아리 오크",
  "$3947": "공간의 일그러짐",
  "$3948": "발록의 대장장이",
  "$3949": "발록의 첩자",
  "$3950": "야히의 시종",
  "$3951": "발록의 보좌관",
  "$3952": "지친 리자드 맨 전사",
  "$3953": "모네 뜨",
  "$3954": "슈인",
  "$3955": "에니 시​​아",
  "$3957": "오염 된 오크",
  "$3958": "오염 된 오크 궁수",
  "$3959": "오염 된 오크 전사",
  "$3960": "오염 된 사이클롭스",
  "$3961": "오염 된 간디 오크",
  "$3962": "오염 된 두다 - 마라 오크",
  "$3963": "오염 된 엔트",
  "$3964": "오염 된 페어리",
  "$3966": "오염 된 오우거",
  "$3967": "오염 된 트롤",
  "$3989": "마르",
  "$3990": "아라스",
  "$4005": "오염 된 펑 거스",
  "$4028": "드레이크의 영혼",
  "$4029": "magic box left npc",
  "$4031": "rune wall",
  "$4043": "지휘관 에스테반",
  "$4072": "아기 진돗개",
  "$4073": "진돗개",
  "$4075": "배틀 타이거",
  "$4076": "골드 드래곤",
  "$4077": "아기 판다 곰",
  "$4078": "공포의 판다 곰",
  "$4079": "아기 캥거루",
  "$4080": "불꽃의 캥거루",
  "$4081": "젊은 원숭이",
  "$4082": "슈퍼 멍키",
  "$4083": "아주르 해츨링",
  "$4084": "크림슨 해츨링",
  "$4085": "하이 아주르 해츨링",
  "$4086": "하이 크림슨 해츨링",
  "$4148": "스피 리드",
  "$4149": "스피 리드의 소환물",
  "$4208": "장로 노나메",
  "$4278": "조사 단장 아 투바 노아",
  "$4279": "두다 마라 카메",
  "$4280": "네루가 바쿠 모",
  "$4281": "네루가 후 우모",
  "$4282": "두다 마라 부카",
  "$4285": "저주받은 다크 엘프 투사",
  "$4286": "저주받은 다크 엘프 기사",
  "$4287": "저주받은 다크 엘프 마법사",
  "$4289": "익사 한 남성",
  "$4290": "익사 한 여성",
  "$4291": "반어 인",
  "$4292": "심해어",
  "$4293": "대왕 오징어",
  "$4294": "뼈 뱀장어",
  "$4295": "진명 황 단테스",
  "$4296": "대법관 바로 드",
  "$4297": "대법관 바로 메스",
  "$4298": "대법관 라미 아스",
  "$4299": "대법관 이데아",
  "$4300": "대법관 케이",
  "$4301": "대법관 티아 메스",
  "$4302": "대법관 비아 타스",
  "$4303": "대법관 엔디 아스",
  "$4304": "장로 수행원",
  "$4305": "pigeon group",
  "$4306": "오튜",
  "$4307": "와이번",
  "$4308": "튜폰",
  "$4309": "우두머리 반어 인",
  "$4310": "심해의 크로커다일",
  "$4311": "심해의 구울",
  "$4312": "심해의 좀비",
  "$4313": "심해의 미믹",
  "$4314": "심해의시 댄서",
  "$4315": "심해의 크랩 맨",
  "$4316": "헐 거인 조사원",
  "$4317": "심해의 일 렉카 둠",
  "$4318": "심해의 크러스트 시안",
  "$4319": "베히 크",
  "$4331": "모래 무덤",
  "$4332": "디고",
  "$4333": "주디 고",
  "$4334": "앙 가스",
  "$4335": "디앙 가스",
  "$4336": "파사 즈",
  "$4337": "파즈",
  "$4340": "이리스",
  "$4346": "사엘",
  "$4347": "저주받은 무녀 사엘",
  "$4359": "에바 왕국의 악령",
  "$4360": "카푸",
  "$4361": "자이언트 웜",
  "$4382": "근위대 장 샤이 블릿",
  "$4383": "라스타바드 근위대",
  "$4454": "쓰러져가는 항해사",
  "$4465": "부제 사장 카산드라",
  "$4471": "지질 탐사 원",
  "$4472": "탐사 원의 조수",
  "$4473": "스크와 루",
  "$4477": "페리 타",
  "$4571": "룸 티스",
  "$4574": "대장장이 아 델리오",
  "$4577": "장로 수행원 쿠로렌스",
  "$4599": "부관 마루베스",
  "$4614": "아타 로제",
  "$4641": "차원의 문",
  "$4642": "울프 비스트 테이머",
  "$4645": "집정관",
  "$4646": "흔들 거리는 사람",
  "$4647": "업의 관리자",
  "$4652": "은밀한 혈거 인 조사원",
  "$4653": "심해의 숨은 미믹",
  "$4654": "숨어있는 반어 인",
  "$4655": "마음이 약한 심해어",
  "$4656": "두다 마라 부우",
  "$4664": "두다 마라 바우",
  "$4691": "야히의 대장장이",
  "$4692": "야히의 보좌관",
  "$4693": "연구원",
  "$4733": "세루 만",
  "$4734": "자이언트 히드라",
  "$4798": "흑 마법사 마야",
  "$4799": "텔레 포터^사자 플로라",
  "$4800": "선한 사자 아멜리아",
  "$4801": "탐욕스런 병사",
  "$4802": "탐욕스런 전사",
  "$4803": "탐욕스런 궁수",
  "$4804": "탐욕스런 마법사",
  "$4806": "경비견",
  "$4807": "백작 친위대 장",
  "$4808": "타로스 백작",
  "$4809": "맘몬",
  "$4818": "텔레 포터^시종장 마몬",
  "$4820": "제 이프",
  "$4821": "에 마이",
  "$4822": "로우 기",
  "$4823": "디에 쯔",
  "$4841": "에셈",
  "$4849": "발바 도스",
  "$4850": "텔레 포터^치안 단장 아 미스",
  "$4851": "마야의 소환물",
  "$4863": "마야의 그림자",
  "$4867": "마이 노 샤먼",
  "$4868": "마이 노",
  "$4869": "마이 노 샤먼의 돌 골렘",
  "$4870": "마이 노 샤먼의 다이아몬드 골렘",
  "$4871": "마이 노 샤먼의 라바 골렘",
  "$4872": "마이 노 샤먼의 아이언 골렘",
  "$4873": "마이 노 샤먼의 리빙 아머",
  "$4881": "텔레 포터^포워르",
  "$4882": "토 두람",
  "$4883": "마법의 벽",
  "$4886": "엔델",
  "$4939": "알 드란",
  "$4942": "야히의 군사",
  "$4943": "발록의 군사",
  "$4947": "심해의 상어",
  "$4972": "라버 본 나이프",
  "$4973": "선박의 악령 소환물",
  "$4986": "선택되지 않았던 사람",
  "$4988": "보초병",
  "$5029": "제론",
  "$5030": "용병 단장 티온",
  "$5031": "신관^지브릴",
  "$5108": "요리 재료 상인^라 쿳키",
  "$5109": "원한에 찬 병사 유령",
  "$5110": "원한에 찬 남자 유령",
  "$5112": "원한에 찬 하멜 장군",
  "$5113": "치안 대장 라르손",
  "$5144": "첩보원",
  "$5162": "오염 된 브롭",
  "$5164": "아덴 기마 단원",
  "$5184": "공성 깃발",
  "$5187": "물의 정령 소환물",
  "$5190": "오스틴",
  "$5191": "필리스",
  "$5199": "케 플리 샤",
  "$5200": "샤론",
  "$5201": "쿠엔",
  "$5202": "수상한 오크 상인 파룸",
  "$5203": "유령의 집 관리인 듀오",
  "$5208": "신비의 구슬 '점성술사의 관 \"",
  "$5209": "장식 숍 \"아름다운 집\"",
  "$5210": "제단",
  "$5216": "고대 품 상점 \"행운의 집\"",
  "$5217": "플라워 숍 '향기의 집'",
  "$5222": "늑대 인간 마법 인형",
  "$5223": "버그 베어 마법 인형",
  "$5224": "서큐버스 마법 인형",
  "$5232": "현상범 쿠작",
  "$5252": "다크 엘프 패잔병",
  "$5276": "낚시터 가이드^폴",
  "$5277": "마르코",
  "$5278": "알프레드",
  "$5279": "흰 개미 무리",
  "$5280": "거대 흰 개미",
  "$5281": "거대 강화 개미",
  "$5282": "산성 개미 무리",
  "$5283": "거대 돌격 개미",
  "$5284": "거대 산성 개미",
  "$5285": "거대 수호 개미",
  "$5290": "오로라",
  "$5292": "카멜",
  "$5293": "체이스",
  "$5294": "제리코",
  "$5295": "레디 아",
  "$5297": "미셸",
  "$5298": "포비",
  "$5299": "에리 샤",
  "$5300": "드로시",
  "$5301": "나타샤",
  "$5302": "미 노엘",
  "$5309": "데스 매치 관리인 쿠산",
  "$5310": "데스 매치 관리인 다투",
  "$5311": "윈스톤",
  "$5312": "펫 매치 관리인",
  "$5313": "메달 보상 관리인",
  "$5319": "개미의 알",
  "$5324": "수상한 애완 동물 트레이너",
  "$5394": "마이진",
  "$5414": "장로 마법 인형",
  "$5415": "크러스트 시안 마법 인형",
  "$5416": "돌 골렘 마법 인형",
  "$5445": "청소 개미",
  "$5449": "아이템 교환 사람^인장 판매 인",
  "$5492": "테베 만드라고라",
  "$5493": "테베 갑충 석",
  "$5494": "테베 칼 비스",
  "$5495": "테베 오벨리스크",
  "$5496": "테베 스핑크스",
  "$5497": "테 베니 호스",
  "$5498": "테 베니 바스",
  "$5499": "테베 니아 무스",
  "$5500": "테베 아누비스",
  "$5501": "테베 호루스",
  "$5502": "얼음 여왕 근위병",
  "$5521": "백 마법사 피에타",
  "$5522": "영혼의 포식자",
  "$5524": "애완 레이스 관리인^두뽀",
  "$5525": "아이스 데몬",
  "$5526": "기란 깃발",
  "$5590": "기란 깃발",
  "$5650": "좀비 엘모어 마샬",
  "$5651": "솔 샤이 카의 영혼",
  "$5652": "화이트 개미 시체",
  "$5653": "화이트 개미의 흔적 (토)",
  "$5654": "화이트 개미의 흔적 (산성 액)",
  "$5655": "화이트 개미의 흔적 (달걀 껍질)",
  "$5656": "시간의 균열",
  "$5657": "푸른 영혼의 불꽃",
  "$5658": "사비우스",
  "$5746": "제사장 기뇰",
  "$5747": "기뇰의 전사",
  "$5748": "기뇰의 투사",
  "$5751": "기뇰의 감시자",
  "$5752": "버려진 육신",
  "$5753": "고결한 의지의 전사",
  "$5754": "고결한 의지의 투사",
  "$5755": "재생의 제단",
  "$5770": "고결한 의지의 수호자",
  "$5777": "성소의 입구",
  "$5788": "오크 밀사 리더",
  "$5790": "행정관 키호루",
  "$5800": "디 가르뎅의여 첩보원",
  "$5801": "마족의 암살단",
  "$5866": "장로 시루 레인",
  "$5867": "마법 판매자^스비에 루",
  "$5868": "텔레 포터^샤리에 루",
  "$5869": "대장장이^바 토루",
  "$5870": "가이드",
  "$5871": "가이드",
  "$5872": "장로 프로 켈",
  "$5873": "마법 판매자^제 빠루",
  "$5874": "텔레 포터^데카 비아",
  "$5875": "대장장이^퓨알",
  "$5876": "타 리온",
  "$5877": "에루 라스",
  "$5885": "변신 주문서 판매 인^샤르",
  "$5886": "시 댄서 마법 인형",
  "$5902": "평화의 사자^유리스",
  "$5919": "붉은 영혼의 불꽃",
  "$6068": "디 가르뎅의 첩보원",
  "$6071": "오크 밀사",
  "$6077": "테베 오시리스 제단 골키퍼",
  "$6084": "실베리아 텔레 포터^환 술사 아샤",
  "$6085": "베히모스 텔레 포터^드래곤 나이트 피 에나",
  "$6334": "오크 밀사 호위병",
  "$6416": "예티 마법 인형",
  "$6434": "쿠 쿨칸 제단 골키퍼",
  "$6436": "에쿠 아즈 테",
  "$6437": "에쿠유카",
  "$6438": "에쿠 쥬라 카",
  "$6439": "에쿠부라",
  "$6440": "에쿠엣토",
  "$6441": "쟈도토우",
  "$6442": "자드 스케",
  "$6443": "자드 테오",
  "$6444": "제부레쿠이",
  "$6446": "보석 세공 장인^데이비드",
  "$7372": "스네이크",
  "$7399": "스파 토이 마법 인형",
  "$7441": "텔레 포터^마법사 멀린",
  "$7442": "기란 산적",
  "$7443": "산적 두목 클라인",
  "$7444": "파우스트의 악령",
  "$7445": "파우스트",
  "$7446": "굶주린 간수",
  "$7447": "굶주린 죄인",
  "$7450": "라미아 마법 인형",
  "$7452": "미니 게임 보상 전문가^팽이",
  "$7493": "로드 마법 인형",
  "$7494": "나이트 마법 인형",
  "$7495": "요정 마법 인형",
  "$7496": "마법사 마법 인형",
  "$7497": "다크 엘프 마법 인형",
  "$7498": "용 기사 마법 인형",
  "$7499": "환 술사 마법 인형",
  "$7510": "코카 트리스 마법 인형",
  "$7560": "케레니스",
  "$7597": "magic-boll",
  "$7655": "바포메트",
  "$7712": "마조 신",
  "$7714": "천리안 신명",
  "$7715": "큰 도깨비 신명",
  "$7740": "항목 제작사^강인한 하이오스",
  "$7741": "항목 제작사^세심한 슈누",
  "$7742": "항목 제작사^끈기있는 도오호",
  "$7743": "항목 제작사^화려한 바에미",
  "$7744": "드루가 가방 판매 인^드루가 베일",
  "$7746": "드래곤 키 판매 알림 게시판",
  "$7747": "드래곤 포탈",
  "$7754": "코마유무",
  "$7755": "그림자 슬립",
  "$7756": "코마 쿰",
  "$7757": "해츨링",
  "$7766": "드워프 작업자",
  "$7767": "드워프 센티넬",
  "$7768": "드워프 제너럴",
  "$7769": "드워프 주술사",
  "$7770": "유니 드래곤 (물)",
  "$7771": "테라 드래곤",
  "$7772": "스컬 드래곤",
  "$7773": "상점^행크",
  "$7774": "해츨링 교환 사람^뱅크",
  "$7775": "상인^만쿠",
  "$7776": "이루바기루",
  "$7777": "빠미리도",
  "$7892": "항목 제작사^슈 에르 메",
  "$7918": "wall",
  "$7919": "magic-boll",
  "$7920": "연구원 조수",
  "$8415": "오색 진주",
  "$8416": "신비한 오색 진주",
  "$8417": "아로호스네로",
  "$8418": "아로호스메가",
  "$8419": "아로호스비아",
  "$8420": "토루나루",
  "$8421": "카이무사무",
  "$8422": "베아사무",
  "$8423": "커다란 조개",
  "$8424": "포탄",
  "$8446": "초보자 가이드^초보자 안내 인",
  "$8447": "초보자 가이드^수련장 관리인",
  "$8453": "공지 사항 소년",
  "$8481": "초보자 가이드^여행자 안내 인",
  "$8549": "추가 창고^바자",
  "$8550": "추가 창고^바다 루",
  "$8551": "추가 창고^바 고루",
  "$8552": "추가 창고^바 사루",
  "$8553": "추가 창고^바 마루",
  "$8554": "추가 창고^바 노르",
  "$8555": "추가 창고^바오 루",
  "$8556": "추가 창고^바 호루",
  "$8557": "추가 창고^바 카르",
  "$8558": "추가 창고^바 토루",
  "$8559": "추가 창고^바 챠루",
  "$8560": "연금술사^로센",
  "$8562": "연금술사^후라 메스",
  "$8563": "연금술사^아루 헤 루스",
  "$8564": "연금술사^셋톤",
  "$8565": "연금술사^루 바루 몬",
  "$8566": "연금술사^샤리 루엔",
  "$8567": "연금술사^도리 스토",
  "$8568": "연금술사^뿌 헤스",
  "$8569": "연금술사^리오스 토",
  "$8572": "시장 텔레 포터",
  "$8573": "시장 텔레 포터",
  "$8574": "시장 텔레 포터",
  "$8575": "시장 텔레 포터",
  "$8591": "다크 나이트",
  "$8594": "연금술사^레오 루빈",
  "$8595": "실버 나이트",
  "$8596": "실버 매지 스터",
  "$8597": "실버 레인저",
  "$8599": "소드 마스터",
  "$8600": "마법사 리 마스터",
  "$8601": "애로우 마스터",
  "$8603": "아크 나이트",
  "$8604": "아크 마법사",
  "$8605": "아크 스카우터",
  "$8607": "다크 매지 스터",
  "$8608": "다크 레인저",
  "$8949": "용의 계란",
  "$8983": "공간 이동 전문가",
  "$8984": "먼 연구원",
  "$8985": "화장 전문가",
  "$8987": "호반",
  "$8988": "특전 아이템 관리자",
  "$8991": "잡화 상인^시비레",
  "$8992": "프레디",
  "$8997": "코트 제비",
  "$8998": "뻬루뻬루",
  "$8999": "페르 티아 가루다 A",
  "$9000": "메탈 골렘 (地)",
  "$9001": "구름의 대 정령",
  "$9002": "수상한 암운",
  "$9130": "여행 사람",
  "$9131": "먼 상인",
  "$9139": "소스 상인^미엘",
  "$9140": "허브 상인^시오 루",
  "$9153": "강화 마법사^텔",
  "$9154": "강화 마법사^메베루",
  "$9155": "강화 마법사^신테루",
  "$9156": "강화 마법사^로도루",
  "$9157": "강화 마법사^룬도루",
  "$9158": "강화 마법사^젠도루",
  "$9159": "강화 마법사^마이베루",
  "$9160": "강화 마법사^덴루",
  "$9161": "강화 마법사^테루로루",
  "$9162": "강화 마법사^나니에루",
  "$9163": "강화 마법사^네베루",
  "$9462": "특산물 관리인^모 포",
  "$9470": "밀매^코뻬 온바",
  "$9567": "올 딘",
  "$9577": "시 하피",
  "$9578": "시드 레이크",
  "$9591": "큐브 [균형]",
  "$9684": "키루 톤",
  "$9685": "메린",
  "$9843": "하린",
  "$10130": "눈싸움 요정",
  "$10149": "눈사람 마법 인형",
  "$11449": "비련",
  "$11450": "제프",
  "$11451": "아 루시아",
  "$11468": "인어 마법 인형",
  "$11469": "노력하는 인어 마법 인형",
  "$11470": "현명한 인어 마법 인형",
  "$11471": "똑똑한 인어 마법 인형",
  "$11472": "빛나는 인어 마법 인형",
  "$11473": "눈부신 인어 마법 인형",
  "$11513": "마술사 아도니스",
  "$11514": "하딘의 분신",
  "$11515": "베레스의 분신",
  "$11516": "바포메트의 분신",
  "$11517": "데몬의 분신",
  "$11525": "외로운 정령",
  "$11536": "짐승 마법 인형",
  "$11537": "노력하는 짐승 마법 인형",
  "$11538": "영리한 짐승 마법 인형",
  "$11539": "똑똑한 짐승 마법 인형",
  "$11540": "빛나는 에틴 마법 인형",
  "$11541": "눈부신 짐승 마법 인형",
  "$11542": "자이언트 마법 인형",
  "$11543": "노력하는 거대한 마법 인형",
  "$11544": "현명한 자이언트 마법 인형",
  "$11545": "똑똑한 자이언트 마법 인형",
  "$11546": "빛나는 자이언트 마법 인형",
  "$11547": "눈부신 자이언트 마법 인형",
  "$11548": "사이클롭스 마법 인형",
  "$11549": "노력하는 사이클롭스 마법 인형",
  "$11550": "현명한 사이클롭스 마법 인형",
  "$11551": "똑똑한 사이클롭스 마법 인형",
  "$11552": "빛나는 사이클롭스 마법 인형",
  "$11553": "눈부신 사이클롭스 마법 인형",
  "$11700": "마법의 버섯",
  "$11993": "サンド ワーム",
  "$12121": "라스타바드 큐브",
  "$12249": "텔레 포터^피터",
  "$12331": "연금술사^무 부니",
  "$12332": "텔레 포터^마에노 부",
  "$12367": "텔레 포터^마에노 부의 불꽃",
  "$12400": "왜곡의 제니스 퀸",
  "$12401": "불신의 시어",
  "$12402": "공포의 뱀파이어",
  "$12403": "죽음의 좀비로드",
  "$12404": "지옥의 쿠거",
  "$12405": "불사의 머미로드",
  "$12406": "냉혹 아이리스",
  "$12407": "어둠의 나이트 발드",
  "$12408": "불멸의 리치",
  "$12409": "사신 그림 리퍼",
  "$12410": "감독 리퍼",
  "$12447": "우구 누스",
  "$12854": "드레이크 마법 인형",
  "$13561": "佐 ノ 길",
  "$13720": "쟈카루",
  "$13721": "카쟈루",
  "$13724": "케빠루레",
  "$13725": "리칸토",
  "$13726": "도라카",
  "$13733": "호노스오쿠",
  "$13738": "네쿠로스",
  "$13739": "오루쿠스",
  "$13740": "드웰 그 제너럴",
  "$13741": "드웰 그 화이트 셔먼",
  "$13742": "드웰 그 소드맨",
  "$13743": "드웰 그 창병",
  "$13744": "드웰 그 도끼 병",
  "$13745": "드웰 그 아처",
  "$13747": "아루휘아",
  "$13748": "흑기사",
  "$13749": "루퍼스",
  "$13751": "만년 슬라임",
  "$13818": "항목 제작사^코끼리 라바 골렘",
  "$13842": "바포메트의 추종자",
  "$13852": "시련의 굴",
  "$13853": "시련의 해골 근위병",
  "$13854": "시련의 웅 골리 언트",
  "$13877": "포노 스 오크 소드맨",
  "$13878": "포노 스 오크 도끼",
  "$13879": "포노 스 오크 궁수",
  "$13880": "포노 스 오크 주술사",
  "$13881": "오크 주술사",
  "$13882": "오크 병사",
  "$13883": "오크 궁수",
  "$13885": "오크 소드맨",
  "$13886": "오크 창병",
  "$14381": "히노 모토 혜택 여장",
  "$14397": "잭 오 랜턴",
  "$14398": "잭 오 - 랜턴",
  "$14399": "잭 오ゥ · 랜턴",
  "$14413": "울 솥",
  "$14414": "갓파",
  "$14415": "카마 이타치",
  "$14416": "우귀",
  "$14417": "ろくろ首",
  "$14418": "종이 우산 귀신",
  "$14419": "없는 네",
  "$14420": "붉은 악마",
  "$14421": "텐구",
  "$14422": "가샤 촉루",
  "$14423": "아수라 상",
  "$14424": "白面 황금 머리 구미호 · 玉藻",
  "$14425": "白面 황금 머리 구미호 · 구미호",
  "$14426": "白面 황금 머리 구미호 · 살생 석",
  "$14451": "호랑이 助",
  "$14452": "소 로쿠",
  "$14453": "만키 치",
  "$14454": "시간의 균열",
  "$14707": "성난 울 솥",
  "$14708": "카마 이타치 맏형",
  "$14709": "환상 우귀",
  "$14798": "소 악마 새끼"
});
